export default __webpack_public_path__ + "static/media/defending.827e70bb.md";